import axios, { InternalAxiosRequestConfig } from 'axios';

/**
 * Request Interceptor: Handles logic before the request is sent.
 */
export const onRequest = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    // 1. Attach default headers if needed (auth logic can be added here later)
    config.headers['Content-Type'] = 'application/json';

    // 2. Log request info in development mode only
    if (process.env.NODE_ENV === 'development') {
        console.log(`[API Request] ${config.method?.toUpperCase()} ${config.url}`, {
            params: config.params,
            data: config.data,
        });
    }

    return config;
};
